import React, { useEffect, useState } from 'react';

import { LoginActions } from '../actions';
import { Mixpanel } from '../utils';
import SignalR from '../services/SignalR';
import { urlB64ToUint8Array } from '../utils/urlB64ToUint8Array';

export const AuthContext = React.createContext();


const AuthProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(window.localStorage.accessToken ? true : false);
  const [user, setUser] = useState(window.localStorage.accessToken ? JSON.parse(window.localStorage.user) : null);

  useEffect(() => {
    if (isLoggedIn) {
      if (window.localStorage.getItem('expirationTokenDate') < new Date()) {
        logOut();
      } else {
        checkToken();
      }
    } 
  }, []);

  useEffect(() => {
    if (user) {
      Mixpanel.Identify(user); 
    }
  }, [user])


  const logIn = userData => {
    SignalR.start(userData.encryptedAccessToken);
    SignalR.register(userData.userId);
    let expirationTokenDate = new Date();
    expirationTokenDate.setSeconds(expirationTokenDate.getSeconds() + userData.expireInSeconds);

    window.localStorage.setItem('accessToken', userData.accessToken);
    window.localStorage.setItem('encryptedAccessToken', userData.encryptedAccessToken);
    window.localStorage.setItem('user', JSON.stringify({ ...userData.user, id: userData.userId }));
    window.localStorage.setItem('expirationTokenDate', expirationTokenDate);
    setIsLoggedIn(true);
    setUser(userData.user);
    subscribeToPushNotification(userData.userId);
  }

  const logOut = () => {
    window.localStorage.clear();
    setIsLoggedIn(false);
    setUser(null);
    window.location.reload();
  }

  const checkToken = async () => {
    const tokenIsValid = await LoginActions.getIfTokenIsValid();
    Mixpanel.Identify(user);
    (!tokenIsValid || !tokenIsValid.isValid) && logOut();
    
  }

  const subscribeToPushNotification = (userId) => {
    const applicationServerPublicKey = 'BIR2hc4PX0YO0KIJ3GfsasSYtyPMSfALGtsTchcYwKHEx7pxPTRWNmvYqdY132VqfLkUBg7-aJNkh7gjg89RWDU';
    const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
    console.log('suscribing');
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      console.log('Service Worker and Push is supported');
      Notification.requestPermission().then(() => {
        navigator.serviceWorker.ready.then(swRegistration => {
          swRegistration.pushManager.getSubscription()
            .then(async function (subscription) {
              let isSubscribed = !(subscription === null);
              const subscriptionJSON = JSON.parse(JSON.stringify(subscription));

              if (isSubscribed) {
                LoginActions.existSubscription({
                    endpoint: subscriptionJSON.endpoint,
                    ...subscriptionJSON.keys,
                    userId,
                });
                console.log('User IS subscribed.', subscriptionJSON);
              } else {
                swRegistration.pushManager.subscribe({
                  userVisibleOnly: true,
                  applicationServerKey: applicationServerKey
                })
                  .then(function (subscription) {
                    const subscriptionJSON = JSON.parse(JSON.stringify(subscription));

                    console.log('User is subscribed:', subscriptionJSON);
                    LoginActions.createSubscription({ 
                      endpoint: subscriptionJSON.endpoint,
                      ...subscriptionJSON.keys,
                      userId,
                    });
  
                  })
                  .catch(function (err) {
                    console.log('Failed to subscribe the user: ', err);
                  })
                console.log('User is NOT subscribed.');
              }
            })
            .catch(function (error) {
              console.error('Service Worker Error', error.message);
            });
        });
      })
    } else {
      console.warn('Push messaging is not supported');
    }
  }


  return (
    <AuthContext.Provider
    value={{
      isLoggedIn,
      user,
      logIn: logIn,
      logOut: logOut,
    }}
  >
    {props.children}
  </AuthContext.Provider>
  )
}

export const Consumer = AuthContext.Consumer;
export const Provider = AuthProvider;
